/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbSuiviApprenantGridDto } from './FcbSuiviApprenantGridDto';
import {
    FcbSuiviApprenantGridDtoFromJSON,
    FcbSuiviApprenantGridDtoFromJSONTyped,
    FcbSuiviApprenantGridDtoToJSON,
} from './FcbSuiviApprenantGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbSuiviApprenantGridDtoPaginatedResults
 */
export interface FcbSuiviApprenantGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbSuiviApprenantGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbSuiviApprenantGridDto>}
     * @memberof FcbSuiviApprenantGridDtoPaginatedResults
     */
    results?: Array<FcbSuiviApprenantGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbSuiviApprenantGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbSuiviApprenantGridDtoPaginatedResults interface.
 */
export function instanceOfFcbSuiviApprenantGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbSuiviApprenantGridDtoPaginatedResultsFromJSON(json: any): FcbSuiviApprenantGridDtoPaginatedResults {
    return FcbSuiviApprenantGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbSuiviApprenantGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbSuiviApprenantGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbSuiviApprenantGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbSuiviApprenantGridDtoPaginatedResultsToJSON(value?: FcbSuiviApprenantGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbSuiviApprenantGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

